import { Box, Input, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const ACCENT = 'var(--mantine-color-smartico-pink-6)';

const PositionTile = ({ value, label, isFavicon, selected, onClick }) => (
    <Box
        onClick={onClick}
        style={{
            width: 74, cursor: 'pointer', borderRadius: 'var(--mantine-radius-md)', padding: '5px 5px 4px',
            border: selected ? `2px solid ${ACCENT}` : '1.5px solid var(--mantine-color-gray-3)',
            display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center',
            backgroundColor: 'var(--mantine-color-body)',
        }}
    >
        <Box style={{ width: '100%', aspectRatio: '300 / 250', background: 'var(--mantine-color-gray-1)', borderRadius: 4, position: 'relative', overflow: 'hidden' }}>
            <Box
                style={{
                    position: 'absolute', top: 6, display: 'flex', alignItems: 'center', gap: 2,
                    ...(value === '1' ? { left: 6 } : value === '3' ? { right: 6 } : { left: '50%', transform: 'translateX(-50%)' }),
                }}
            >
                {isFavicon ? (
                    <>
                        <Box style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--mantine-color-gray-6)' }} />
                        <Box style={{ width: 12, height: 4, borderRadius: 1.5, background: 'var(--mantine-color-gray-5)' }} />
                    </>
                ) : (
                    <Box style={{ width: 16, height: 5, borderRadius: 1.5, background: 'var(--mantine-color-gray-6)' }} />
                )}
            </Box>
            <Box style={{
                position: 'absolute', left: 9, right: 9, top: '45%', height: 8, borderRadius: 1.5, opacity: .8,
                background: 'repeating-linear-gradient(180deg, var(--mantine-color-gray-4) 0 2.5px, transparent 2.5px 6.5px)',
            }} />
            <Box style={{
                position: 'absolute', left: '50%', transform: 'translateX(-50%)', bottom: 6,
                width: '42%', height: 5, borderRadius: 1.5, background: 'var(--mantine-color-gray-5)',
            }} />
        </Box>
        <Text size={10.5} lh={1.3} fw={600} c={selected ? 'var(--mantine-color-text)' : 'dimmed'}>{label}</Text>
    </Box>
);

export const PositionComponent = ({ isFavicon, value, defaultValue, onChange, label, ...props }) => {
    const { t } = useTranslation();
    const values = isFavicon ? ['1', '3'] : ['1', '2', '3'];
    const currentValue = value ?? defaultValue;

    return (
        <Box {...props.wrapperProps} fullWidth>
            {label && <Input.Label>{label}</Input.Label>}
            <Box style={{ display: 'flex', gap: 8 }}>
                {values.map((v) => (
                    <PositionTile
                        key={v}
                        value={v}
                        label={t({ '1': 'logo.positionLeft', '2': 'logo.positionCenter', '3': 'logo.positionRight' }[v])}
                        isFavicon={isFavicon}
                        selected={currentValue === v}
                        onClick={() => onChange(v)}
                    />
                ))}
            </Box>
        </Box>
    );
}
